import axios from 'axios'
import global from '@/global/variable.js'

// 获取日统计数据
export function getRouterList() {
  const url = global.requestUrl + '/menu/navigate'
  return axios.post(url)
}